module.exports = "/images/icon-completed.png?6938e38e1530f2aba9f4063d89406bcd";